class TestimonialCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-track]');
    this.prevButton = this.querySelector('[data-prev]');
    this.nextButton = this.querySelector('[data-next]');
    this.dotsContainer = this.querySelector('[data-dots]');

    if (!this.track) return;

    this.slides = Array.from(this.track.children);
    if (this.slides.length === 0) return;

    this.activeIndex = 0;
    this.buildDots();
    this.updateControls();

    this.prevButton?.addEventListener('click', () => this.goTo(this.activeIndex - 1));
    this.nextButton?.addEventListener('click', () => this.goTo(this.activeIndex + 1));

    this.observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            const index = this.slides.indexOf(entry.target);
            if (index !== -1) this.setActive(index);
          }
        }
      },
      { root: this.track, threshold: 0.6 }
    );
    this.slides.forEach((slide) => this.observer.observe(slide));
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  buildDots() {
    if (!this.dotsContainer) return;
    if (this.slides.length < 2) {
      this.dotsContainer.hidden = true;
      if (this.prevButton) this.prevButton.hidden = true;
      if (this.nextButton) this.nextButton.hidden = true;
      return;
    }
    this.dotsContainer.innerHTML = '';
    this.dots = this.slides.map((_, index) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'testimonial-carousel__dot';
      dot.setAttribute('aria-label', `Go to review ${index + 1}`);
      dot.addEventListener('click', () => this.goTo(index));
      this.dotsContainer.appendChild(dot);
      return dot;
    });
  }

  goTo(index) {
    const clamped = Math.max(0, Math.min(index, this.slides.length - 1));
    this.slides[clamped].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
  }

  setActive(index) {
    this.activeIndex = index;
    this.dots?.forEach((dot, i) => {
      dot.setAttribute('aria-current', i === index ? 'true' : 'false');
    });
    this.updateControls();
  }

  updateControls() {
    if (this.prevButton) this.prevButton.disabled = this.activeIndex === 0;
    if (this.nextButton) this.nextButton.disabled = this.activeIndex === this.slides.length - 1;
    this.dots?.forEach((dot, i) => {
      dot.setAttribute('aria-current', i === this.activeIndex ? 'true' : 'false');
    });
  }
}

if (!customElements.get('testimonial-carousel')) {
  customElements.define('testimonial-carousel', TestimonialCarousel);
}
